import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const VoucherForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});

  const [close, setClose] = useState(false);
  const [rejectdisabled, SetRejectdisabled] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [employeeId, setEmployeeId] = useState();
  const [voucherTypeId, setVoucherTypeId] = useState();
  const [modeofPaymentId, setModeOfPaymentId] = useState();

  const [currencyId, setCurrencyId] = useState(null);
  const [currencyData, setCurrencyData] = useState([]);

  const [AccountList, setAccountList] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState();

  const [bankCashAccountId, setBankCashAccountId] = useState(null);
  const [bankCashAccountList, setBankCashAccountList] = useState([]);
 
  const [payeeAccountMappingId, setPayeeAccountMappingId] = useState();
  const [payeeAccountList, setPayeeAccountList] = useState([]);

  const [payableReceivablesList, setPayableReceivablesList] = useState([]);

  const [bankcashaccountMappingId, setBankcashaccountMappingId] = useState();
  const [bankcashaccountMappingData, setBankcashaccountMappingData] = useState(
    []
  );

  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  var d = new Date();

  const { sendRequest: getGatePass } = useHttp();
  const { sendRequest: getCurrecy } = useHttp();

  useEffect(() => {
    getCurrecy(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setCurrencyData(data.output);
      }
    );
  }, [getCurrecy]);

  const { sendRequest: getAccountData } = useHttp();

  const FillAccountDetail = () => {
    getAccountData(
      {
        url: `/api/fillAccountMappingList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          console.log("payeeAccountList", res);
          setAccountList(res);
          var payeelist = res.filter(
            (item) =>
              (item.accountMappedHeadId == 8) || 
              (item.accountMappedHeadId == 4) ||
              (item.accountMappedHeadId == 3) ||
              (item.accountMappedHeadId == 2) ||
              (item.accountMappedHeadId == 1)
          );
          setPayeeAccountList(payeelist);
          var bankaccountlist = res.filter(
            (item) =>
              (item.accountMappedHeadId == 7) ||           
              (item.accountMappedHeadId == 23)  
          );

          setBankcashaccountMappingData(bankaccountlist)
           console.log("bankaccountlist", bankaccountlist);
        }
      }
    );
  };

  useEffect(() => {
    FillAccountDetail();
  }, [getAccountData]);

  const { sendRequest: getPayableReceivables } = useHttp();

  const FillPayableReceivables = (id) => {
    setTotalPaidAmount(0);

    console.log("id", id);
    getPayableReceivables(
      {
        url: `/api/fillPayableReceivablesList/?accountMappingId=${id}&&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log("res", res);
          setPayableReceivablesList(res);
        }
      }
    );
  };

  useEffect(() => {
    FillPayableReceivables(0);
  }, [getPayableReceivables]);

  useEffect(() => {
    frmRef.current.voucherTime.value =
      (d.getHours() < 10 ? "0" : "") +
      d.getHours().toString() +
      ":" +
      (d.getMinutes() < 10 ? "0" : "") +
      d.getMinutes().toString();
    //console.log("time_stamp1", d.getMinutes().toString());
  }, [currencyData]);

  const { sendRequest: postProcurementReciept } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    var paymentVoucherDetail=payableReceivablesList.filter((item)=>item.chkSelect==true)
    const data = {
      paymentVoucherDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      payReceiptType: frmRef.current.voucherTime.value,
      payReceiptType: voucherTypeId,
      employeeId: employeeId,
      bankcashaccountMappingId: bankcashaccountMappingId,
      accountMappingId: payeeAccountMappingId,
      totalPaidAmount:frmRef.current.totalPaidAmount.value,
      currencyId:1,
      exchangeRate:1,
      foreignCurrencyId:1,  
      paymentVoucherDetail:payableReceivablesList,
      status: 1,     
      note: frmRef.current.notes.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
    
    };
    console.log("data", data);
    if (props.update) {
      data["paymentVoucherId"] = props.update.paymentVoucherId;
    }
    postProcurementReciept(
      {
        url: "/api/paymentVoucher/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Voucher detail ${props.update ? "updated" : "added"} `
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const handleCheckBoxChange = (index, event) => {
    payableReceivablesList[index].chkSelect = event.target.checked;
    calculateTotalPaidAmount();
  };
  const handleValidateTotalQuantityChange = (index, event) => {
    var paidAmount = parseFloat(event.target.value ?? 0);
    var balanceAmount = parseFloat(
      payableReceivablesList[index].balanceAmount ?? 0
    );

    if (paidAmount > balanceAmount) {
      event.target.value = 0;
      toast.success(
        "Please enter the paid amount less than and equal to balance amount",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }

    payableReceivablesList[index].paidAmount = paidAmount;
    calculateTotalPaidAmount();
  };

  const calculateTotalPaidAmount = () => {
    //console.log("calculateTotalPaidAmount", payableReceivablesList);
    var totalValue = 0;

    payableReceivablesList.forEach((element) => {
      if (element.chkSelect == true) {


        if(voucherTypeId=="Payment")
        {
          if (element.payReceiptType=="Payment")
          {
            totalValue = totalValue + element.paidAmount;
          }
          if (element.payReceiptType=="Receipt")
          {
            totalValue = totalValue - element.paidAmount;
          }
       }

       if(voucherTypeId=="Receipt")
       {
         if (element.payReceiptType=="Payment")
         {
           totalValue = totalValue -  element.paidAmount;
         }
         if (element.payReceiptType=="Receipt")
         {
           totalValue = totalValue + element.paidAmount;
         }
      }
      
       
      }
    });

    setTotalPaidAmount(totalValue);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Voucher Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-2">
                      <label htmlFor={"voucherTime"}>{"Voucher Time"}</label>
                      <input
                        type={"time"}
                        id={"voucherTime"}
                        required
                        ref={(el) => (frmRef.current["voucherTime"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["employeeId"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option>--Select Employee--</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Voucher Type"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["voucherTypeId"] = el)}
                        value={voucherTypeId}
                        onChange={(e) => {
                          setVoucherTypeId(e.target.value);
                        }}
                      >
                        <option>--Select Voucher--</option>

                        <option>Payment</option>
                        <option>Receipt</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"farmerType"}>
                        {" "}
                        {"Mode Of Payment/Receipt"}
                      </label>

                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["modeOfPayment"] = el)}
                        value={modeofPaymentId}
                        onChange={(e) => {
                          setModeOfPaymentId(e.target.value);
                           
                          console.log("bankcashaccountMappingData",bankcashaccountMappingData)
                          if(e.target.value!="--Select--")
                          {
                            var bankcashlist=[];
                            if(e.target.value=="Cash")
                            {
                              bankcashlist=  bankcashaccountMappingData.filter(e=>e.accountMappedHeadId==7)
                          
                            }else
                            {
                              bankcashlist=  bankcashaccountMappingData.filter(e=>e.accountMappedHeadId!==7)
                          
                            }

                            setBankCashAccountList(bankcashlist)

                          }else
                          {
                            setBankCashAccountList([])
                          }
                        }}
                      >
                        <option value="">--Select--</option>

                        <option>Cash</option>
                        <option>Cheque</option>
                        <option>Bank Transfer</option>
                        <option>Demand Draft</option>
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Bank/Cash Account"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["voucherTypeId"] = el)}
                        value={bankcashaccountMappingId}
                        onChange={(e) => {
                          setBankcashaccountMappingId(e.target.value);
                        }}
                      >
                        
                       
                       <option>--Select--</option>

                        {bankCashAccountList &&
                          bankCashAccountList.map((x) => (
                            <option
                              key={x.accountMappingId}
                              accountMapping-id={x.accountMappingId}
                              value={x.accountMappingId}
                            >
                              {x.mappedName+"("+x.accountName+")"}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Payment/Receipt To"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["payeeAccountMappingId"] = el)
                        }
                        value={payeeAccountMappingId}
                        onChange={(e) => {
                          var id = 0;
                          if (e.target.value != "--Select Voucher--") {
                            id = e.target.value;
                          }
                          setPayeeAccountMappingId(id);
                          FillPayableReceivables(id);
                        }}
                      >
                        <option>--Select--</option>

                        {payeeAccountList &&
                          payeeAccountList.map((x) => (
                            <option
                              key={x.accountMappingId}
                              accountMapping-id={x.accountMappingId}
                              value={x.accountMappingId}
                            >
                              {x.mappedName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">&nbsp; </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th> Select </th>
                          <th> Date</th>
                          <th> Doc No</th>
                          <th> Service Name</th>

                          <th> Payment/Receipt Type</th>
                          <th> Total Amount</th>
                          <th>Balance Amount</th>

                          <th>Paid Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {payableReceivablesList &&
                          payableReceivablesList.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>
                                  <input
                                    type="checkbox"
                                    value={itm.chkSelect}
                                    onChange={(e) => {
                                      handleCheckBoxChange(i, e);
                                    }}
                                  />
                                </td>
                                <td>{itm.payableReceivablesDate}</td>
                                <td>{itm.code}</td>
                                <td>{itm.service}</td>
                                <td>{itm.payReceiptType}</td>

                                <td>{itm.totalamount}</td>
                                <td>{itm.balanceAmount}</td>
                                <td>
                                  <input
                                    type={"text"}
                                    id={"class3"}
                                    defaultValue="0"
                                    required
                                    ref={(el) =>
                                      (frmRef.current["paidAmount"] = el)
                                    }
                                    className="inputs"
                                    onChange={(e) => {
                                      handleValidateTotalQuantityChange(i, e);
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <td colSpan="7"> </td>
                          <td>
                            <input
                              type={"text"}
                              id={"totalPaidAmount"}
                              value={totalPaidAmount}
                              required
                              ref={(el) =>
                                (frmRef.current["totalPaidAmount"] = el)
                              }
                              className="inputs"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                   


                  <div className="row">  

                  <div className="col-md-4">
                  </div>
                  <div className="col-md-4">
                  </div>
                  <div className="col-md-4">
                  <label>Notes</label>
                  <input
                          type={"text"}
                          id={"notes"}
                          required
                          ref={(el) =>
                            (frmRef.current["notes"] = el)
                          }
                          className="form-control"
                        /> </div>

</div>
                  <div className="row">&nbsp; </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default VoucherForm;
